import {
  TRANSLATION_FIELD_FRAGMENT,
  TranslationField,
  TranslationFieldAdapter,
} from "../../../../common/graphql/fragments"
import { Maybe } from "../../../../common/types"
import { FirebaseAdapter } from "../../../../common/utilities"
import { PlainOfferRequestQuestion } from "../../../types"
import {
  OFFER_REQUEST_BASE_QUESTION_FRAGMENT_RAW,
  OfferRequestBaseQuestion,
  OfferRequestBaseQuestionAdapter,
} from "./OfferRequestBaseQuestionInfo"

import { gql } from "@apollo/client"

type QuestionType = "list"

type PlainOfferRequestListQuestion = PlainOfferRequestQuestion & {
  type: QuestionType
}

export interface OfferRequestListPicker
  extends OfferRequestBaseQuestion<QuestionType> {
  placeholder?: Maybe<TranslationField>
  numericValue?: Maybe<number>
}

export const OfferRequestListPickerAdapter = new FirebaseAdapter<
  PlainOfferRequestListQuestion,
  OfferRequestListPicker
>({
  toFirebase: (graphql) => ({
    ...OfferRequestBaseQuestionAdapter.toFirebase(graphql),
    type: "list" as QuestionType,
    placeholder: graphql.placeholder
      ? TranslationFieldAdapter.toFirebase(graphql.placeholder)
      : null,
    value: graphql.numericValue || null,
  }),
  toGraphQL: (firebase) => ({
    ...OfferRequestBaseQuestionAdapter.toGraphQL(firebase),
    type: "list" as QuestionType,
    placeholder:
      firebase.placeholder &&
      TranslationFieldAdapter.toGraphQL(firebase.placeholder),
    numericValue: firebase.value,
  }),
})

export const OFFER_REQUEST_LIST_PICKER_QUESTION_FRAGMENT = gql`
  ${TRANSLATION_FIELD_FRAGMENT}

  fragment OfferRequestListPickerInfo on OfferRequestListPickerDto {
    ${OFFER_REQUEST_BASE_QUESTION_FRAGMENT_RAW}
    placeholder {
      ...TranslationFieldInfo
    }
    numericValue
  }
`
